import { render, staticRenderFns } from "./OrderHistoryMobile.vue?vue&type=template&id=5059e818&scoped=true"
import script from "./OrderHistoryMobile.vue?vue&type=script&lang=js"
export * from "./OrderHistoryMobile.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryMobile.vue?vue&type=style&index=0&id=5059e818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059e818",
  null
  
)

export default component.exports